import React, {useEffect, useState} from "react";
import {Button, IconButton, Option, Select, Typography} from "@material-tailwind/react";
import persianNumberFormat from "../../helper/PersianNumberFormat";
import {BsChevronDoubleLeft, BsChevronDoubleRight, BsChevronLeft, BsChevronRight} from "react-icons/bs";

export function Paginator({
                            totalRows,
                            active,
                            setActive,
                            rowsCount,
                            setRowsCount,
                            from,
                            to
                          }) {
  const [pagesArray, setPagesArray] = useState([]);

  const getItemProps = (index) =>
    ({
      variant: active === index ? "filled" : "text", color: "gray",
      onClick: () => setActive(index),
    });

  const next = () => {
    if (active === pages) return;

    setActive(active + 1);
  };

  const prev = () => {
    if (active === 1) return;

    setActive(active - 1);
  };

  const first = () => {
    if (active === 1) return;

    setActive(1);
  };

  const last = () => {
    if (active === totalRows) return;

    setActive(pages);
  };

  const pages = Math.ceil(totalRows / rowsCount) > 0 ? Math.ceil(totalRows / rowsCount) : 1

  useEffect(() => {
    const pagesArrayFunc = (pages, active) => {
      let result = [];

      if (active > 1) {
        result.push(active - 1);
      }

      result.push(active);

      if (active < pages) {
        result.push(active + 1);
      }

      return result;
    };

    setPagesArray(pagesArrayFunc(pages, active));
  }, [active, pages]);


  return (
    <div className="flex flex-col w-full md:flex-row">

      <div className="flex flex-row mt-4 mx-auto md:mx-0 md:flex-col md:mt-2 md:ml-auto">
        <Select variant="static" size="md" className="max-w-xs" dir="rtl"
                label={"تعداد سطر"}
                value={rowsCount.toString()}
                onChange={(val) => setRowsCount(parseInt(val))}>
          <Option value="5">{persianNumberFormat(5)}</Option>
          <Option value="10">{persianNumberFormat(10)}</Option>
          <Option value="15">{persianNumberFormat(15)}</Option>
        </Select>
      </div>

      <div className="flex flex-row mt-4 mx-auto md:mx-0 md:flex-col md:mt-2">
        <div className="flex items-center">
          <Button
            variant="text"
            className="flex items-center -ml-8"
            onClick={first}
            disabled={active === 1}
          >
            <BsChevronDoubleRight strokeWidth={2} className="h-4 w-4"/>
          </Button>
          <Button
            variant="text"
            className="flex items-center -ml-2"
            onClick={prev}
            disabled={active === 1}
          >
            <BsChevronRight strokeWidth={2} className="h-4 w-4"/>
          </Button>
          <div className="flex items-center">
            <div className="flex flex-row align-baseline">
              {pagesArray.map((page) => (
                <IconButton key={page} {...getItemProps(page)}>
                  {persianNumberFormat(page)}
                </IconButton>
              ))}
            </div>
          </div>
          <Button
            variant="text"
            className="flex items-center -mr-2"
            onClick={next}
            disabled={active === pages}
          >
            <BsChevronLeft strokeWidth={2} className="h-4 w-4"/>
          </Button>
          <Button
            variant="text"
            className="flex items-center -mr-8"
            onClick={last}
            disabled={active === pages}
          >
            <BsChevronDoubleLeft strokeWidth={2} className="h-4 w-4"/>
          </Button>
        </div>

      </div>

      <div className="flex flex-row mt-4 mx-auto md:mx-0 md:flex-col md:mt-2 mx md:mr-auto">
        <Typography color="blue-gray">
          {persianNumberFormat(`نمایش ${from} تا ${to}  از ${totalRows}`)}
        </Typography>
      </div>

    </div>
  );
}